export enum ErrorCode {

  UNKNOWN_ERROR,
  NO_FORM_FOUND,
  COMMUNICATION_FAILURE,
  SITE_KEY_NOT_VALID,
  MODES_NOT_MATCHING,
  CAPTCHA_NOT_ACCESSIBLE,
  POW_FAILURE,
  PAYMENT_REQUIRED,
  LOCKED,
  LICENSE_INVALID,
  OPTION_NOT_AVAILABLE,
  NO_SITE_KEY_SPECIFIED,
}
